import { createStyles, rem } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  wrapper: {
    width: "100vw",
    height: "100vh",
    background: theme.colors.midnightBlue[0],
    padding: rem(20),
    paddingTop: rem(80),
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: 10,
  },
  logoutWrapper: {
    textDecoration: "none",
  },
  divider: {
    borderColor: theme.colors.dusk[0],
  },
}));
